import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {RootState} from 'src/store/store';

export const getChangeRequestInfo = (state: RootState): Record<number, ChangeRequest> =>
    state.changeRequestInfo.data;
